import axios from "axios";
import { ISaveTexture } from "../../../../../common-code/interfaces/materials/ISaveTexture";
import { ISaveImage } from "../../../../../common-code/interfaces/materials/ISaveImage";
import { IMaterialData } from "common-code/lib/interfaces/materials/IMaterialData";
import { TMaterialEditMode } from "../../../../../common-code/types/TMaterialEditMode";

export async function saveTexture(
  texture: ISaveTexture
): Promise<ISaveTexture | undefined> {
  const requestConfig = {
    method: "post",
    url: "/api/materiallist/save-texture",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
    data: texture,
  };
  try {
    const response = await axios(requestConfig);
    return response.data;
  } catch {
    return undefined;
  }
}

export async function saveModel3D(
 data: {
  path: string;
  file: File;
  name: string;
 }
): Promise<string | undefined> {  
  const requestConfig = {
    method: "post",
    url: "/api/materiallist/save-3d-model",
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
    data: data,
  };
  try {
    const response = await axios(requestConfig);
    return response.data;
  }  catch (error: { response: { data: { message: string } } } | any) {
    if (error?.response?.data?.message === "3d модель с таким именем уже существует") {
      alert(error.response.data.message);
    } 
    return undefined;
  }
}



export const saveImage = async (
  imageData: ISaveImage
): Promise<ISaveImage | undefined> => {
  const requestConfig = {
    method: "post",
    url: "/api/materiallist/save-image",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: imageData,
  };

  try {
    const response = await axios(requestConfig);
    return response.data;
  } catch {
    return undefined;
  }
};

export async function saveMaterial(
  materialData: IMaterialData[],
  materialType: TMaterialEditMode,
  collectionId: string
): Promise<IMaterialData[] | undefined> {
  const requestConfig = {
    method: "post",
    url: `/api/materiallist/save-materials/${materialType}/${collectionId}`,
    headers: {
      "Content-Type": "application/json",
    },
    data: materialData,
  };

  const response = await axios(requestConfig);
  return response.data;
}
